<template>
 <div class="container">

<h1><font-awesome-icon icon="home" /> Home  - <a href="#">Tasks </a>

<div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>


  <b-modal id="modal-lg" size="lg" title="Tasks">
   
  <div class="panal">
    <div>
      
      <div class="panal-header"> {{ info.PageName }}</div>
     <div class="panal-body">

  <div v-html="info.PageDescription"></div>
      </div>
     </div>

  

  </div>

    <div class="panal" v-for="help in info.HelpSection" :key="help.serial">
    <div>
      
      <div class="panal-header"> {{ help.SectionName }}</div>
     <div class="panal-body">

     <div v-html="help.SectionDescription"></div>
      </div>
     </div>

 

  </div>

  </b-modal>




</div>


</h1>

 

<div class="row">


 <div class="col-md-12" id="tabs">
<div class="tabs">
        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Current</a>
        <a v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">History</a>
    
    </div>

    <div class="content">
        <div v-if="activetab === 1" class="tabcontent">
          <Current/>
        </div>
        <div v-if="activetab === 2" class="tabcontent">
        <History/>
        </div>
      
    </div>




  </div>







</div>




</div>

</template>

<script>
// import Tap2 from "../../components/Applicant/Tap2.vue";
import Current from "../../components/Applicant/Current.vue";
import History from "../../components/Applicant/History.vue";
import ApplicantService from '../../services/Applicant/Applicant.service';

export default {
   components: {
    Current,History
  
  },
  data () {
    return {
       el: '#tabs',
    activetab: 1,
      info: '',
  
    }
  },

  mounted () {
//ApplicantService.GetHelpPages(1);
let id = 8;
 ApplicantService.GetHelpPages(id).then(response => {
        this.info = response.data
      });

      
  }
}


</script>

<style scoped>
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#ff8600;
}

.panal{

  border-radius:10px;
color:#333;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;


}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}

/* Style the tabs */
.tabs {
    overflow: hidden;
  margin-left: 20px;
    margin-bottom: -2px; 
}

.tabs ul {
    list-style-type: none;
    margin-left: 20px;
}

.tabs a{
    float: left;
    cursor: pointer;
    padding: 12px 24px;
    transition: background-color 0.2s;
    border: 1px solid #ccc;
    border-right: none;
    background-color: #285475;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
     color: #fff;
}
.tabs a:last-child { 
    border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
    background-color: #aaa;
    color: #fff;
}

/* Styling for active tab */
.tabs a.active {
   background-color: #fff;
    color: #285475;
    border-bottom: 2px solid #fff;
    cursor: default;
}

/* Style the tab content */
.tabcontent {
    padding: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  background: #fff;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}


</style>